/**
 * @项目名称: cardloan-h5
 * @功能名称: 数据存储localStorage
 * @文件名称: local
 * @Date: 2018/8/2
 * @Author: liux
 * @Copyright（C）2018 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
var hasLocal = true;
var storage = window.localStorage;
import {parse} from './utils'

if (storage) {
  try {
    storage.setItem('_localStorageTest', 'Hello World!');
    storage.removeItem('_localStorageTest');
  } catch (e) {
    hasLocal = false;
  }
} else {
  hasLocal = false;
}

function getLocal(name) {
  if(!hasLocal){
    return ''
  }
  return parse(storage.getItem(name));
};
function setLocal(name, val) {
  if(!hasLocal){
    return ''
  }
  storage.setItem(name, JSON.stringify(val));
};
function clearLocal(name) {
  if(!hasLocal){
    return ''
  }
  setLocal(name, '');
}

export {
  getLocal,
  setLocal,
  clearLocal,
};